import React, {
    useEffect,
    useMemo,
    useState
} from 'react';

import Modal from 'react-modal';

import {
    ModalEconomiaContenido,
    ModalEconomiaCabecera,
    ModalEconomiaTitulo,
    ModalEconomiaSubtitulo,
    BotonCerrarModal,

    ModalSeccion,
    ModalSeccionTitulo,
    ModalAcciones,
    ModalScrollContenido,

    BotonPrincipal,
    BotonSecundario,

    CobroFormulario,
    CobroCamposGrid,
    CobroCampo,
    CobroLabel,
    CobroInput,
    CobroSelect,
    CobroTextarea
} from '../../Css/StyledEstadisticasCobros.js';


Modal.setAppElement('#root');


/*
====================================
FECHAS
====================================
*/

const getFechaHoy = () => {

    const hoy = new Date();

    const year =
        hoy.getFullYear();

    const month =
        String(
            hoy.getMonth() + 1
        ).padStart(
            2,
            '0'
        );

    const day =
        String(
            hoy.getDate()
        ).padStart(
            2,
            '0'
        );

    return `${year}-${month}-${day}`;
};


const sumarDiasISO = (
    fecha,
    dias
) => {

    const [
        year,
        month,
        day
    ] = String(
        fecha
    )
        .substring(
            0,
            10
        )
        .split('-')
        .map(
            Number
        );

    const date =
        new Date(
            year,
            month - 1,
            day + dias
        );

    const nuevoYear =
        date.getFullYear();

    const nuevoMonth =
        String(
            date.getMonth() + 1
        ).padStart(
            2,
            '0'
        );

    const nuevoDay =
        String(
            date.getDate()
        ).padStart(
            2,
            '0'
        );

    return `${nuevoYear}-${nuevoMonth}-${nuevoDay}`;
};


const formatDateDisplay = (
    fecha
) => {

    if (
        !fecha
    ) {

        return 'Actualidad';

    }

    const [
        year,
        month,
        day
    ] = String(
        fecha
    )
        .substring(
            0,
            10
        )
        .split('-');

    return `${day}/${month}/${year}`;
};


/*
====================================
BOOLEANO
====================================
*/

const getBoolean = (
    valor
) => {

    return (
        valor === true ||
        valor === 1 ||
        valor === '1' ||
        String(
            valor
        ).toLowerCase() ===
            'true'
    );

};


/*
====================================
VENCIMIENTO
====================================
*/

const getVencimientoOpcion = (
    configuracion
) => {

    if (
        configuracion
            ?.vencimiento_tipo ===
            'INMEDIATO'
    ) {

        return 'INMEDIATO';

    }

    if (
        configuracion
            ?.vencimiento_tipo ===
            'FIN_MES' &&
        Number(
            configuracion
                ?.vencimiento_meses ||
            0
        ) ===
            0
    ) {

        return 'FIN_MES_ACTUAL';

    }

    if (
        configuracion
            ?.vencimiento_tipo ===
            'DIA_MES'
    ) {

        return 'DIA_MES_SIGUIENTE';

    }

    return 'FIN_MES_SIGUIENTE';

};


/*
====================================
CONFIGURACIÓN BASE
====================================
*/

const getConfiguracionBase = (

    configuraciones,

    fecha,

    fallback

) => {

    const lista =
        (
            Array.isArray(
                configuraciones
            )

                ? configuraciones

                : []
        )
            .slice()
            .sort(
                (
                    a,
                    b
                ) =>

                    String(
                        a.fecha_desde
                    )
                        .localeCompare(
                            String(
                                b.fecha_desde
                            )
                        )
            );

    const exacta =
        lista.find(
            (item) =>

                String(
                    item.fecha_desde
                )
                    .substring(
                        0,
                        10
                    ) ===
                fecha
        );

    if (
        exacta
    ) {

        return exacta;

    }

    let anterior =
        null;

    for (
        const item
        of lista
    ) {

        const desde =
            String(
                item.fecha_desde
            )
                .substring(
                    0,
                    10
                );

        if (
            desde <
            fecha
        ) {

            anterior =
                item;

        }

    }

    const siguiente =
        lista.find(
            (item) =>

                String(
                    item.fecha_desde
                )
                    .substring(
                        0,
                        10
                    ) >
                fecha
        ) ||
        null;

    return (
        anterior ||
        siguiente ||
        fallback ||
        null
    );

};


/*
====================================
PRIMERA FECHA LIBRE
====================================
*/

const getFechaInicial = (
    configuraciones
) => {

    const usadas =
        new Set(
            (
                Array.isArray(
                    configuraciones
                )

                    ? configuraciones

                    : []
            )
                .map(
                    (item) =>
                        String(
                            item.fecha_desde
                        )
                            .substring(
                                0,
                                10
                            )
                )
        );

    let fecha =
        getFechaHoy();

    while (
        usadas.has(
            fecha
        )
    ) {

        fecha =
            sumarDiasISO(
                fecha,
                1
            );

    }

    return fecha;

};


/*
====================================
ESTADO DESDE CONFIGURACIÓN
====================================
*/

const getEstadoDesdeConfiguracion = (

    configuracion,

    fecha_desde

) => {

    return {

        fecha_desde,

        fee_tipo:
            configuracion
                ?.fee_tipo ||
            'PORCENTAJE',

        fee_valor:
            configuracion
                ?.fee_valor !==
                undefined &&
            configuracion
                ?.fee_valor !==
                null

                ? String(
                    configuracion
                        .fee_valor
                )

                : '',

        fee_base:
            configuracion
                ?.fee_base ||
            'PRESTACION',

        fee_mensual_condicion:
            configuracion
                ?.fee_mensual_condicion ||
            'MES_CON_PRESTACIONES',

        paga_sesion_paciente:
            configuracion

                ? getBoolean(
                    configuracion
                        .paga_sesion_paciente
                )

                : true,

        paga_reunion_padres:
            configuracion

                ? getBoolean(
                    configuracion
                        .paga_reunion_padres
                )

                : false,

        paga_reunion_colegio:
            configuracion

                ? getBoolean(
                    configuracion
                        .paga_reunion_colegio
                )

                : false,

        paga_reunion_profesionales:
            configuracion

                ? getBoolean(
                    configuracion
                        .paga_reunion_profesionales
                )

                : false,

        vencimiento_opcion:
            getVencimientoOpcion(
                configuracion
            ),

        vencimiento_dia:
            configuracion
                ?.vencimiento_dia !==
                undefined &&
            configuracion
                ?.vencimiento_dia !==
                null

                ? String(
                    configuracion
                        .vencimiento_dia
                )

                : '10',

        observacion:
            ''

    };

};


/*
====================================
TEXTO DEL FEE
====================================
*/

const getFeeTexto = (
    configuracion
) => {

    if (
        !configuracion
    ) {

        return '—';

    }

    if (
        configuracion.fee_tipo ===
            'PORCENTAJE'
    ) {

        return `${Number(
            configuracion.fee_valor ||
            0
        )}%`;

    }

    if (
        configuracion.fee_tipo ===
            'FIJO_PRESTACION'
    ) {

        return `$ ${Number(
            configuracion.fee_valor ||
            0
        ).toLocaleString(
            'es-AR'
        )} por prestación`;

    }

    return `$ ${Number(
        configuracion.fee_valor ||
        0
    ).toLocaleString(
        'es-AR'
    )} mensual`;

};


/*
====================================
MODAL
====================================
*/

const ConfiguracionCentroModal = ({

    isOpen,

    onClose,

    centro,

    configuraciones,

    onGuardar,

    guardando

}) => {


    const [
        formulario,
        setFormulario
    ] = useState(
        null
    );

    const [
        errorFormulario,
        setErrorFormulario
    ] = useState(
        ''
    );


    /*
    ====================================
    HISTORIAL ORDENADO
    ====================================
    */

    const historial =
        useMemo(() => {

            return (
                Array.isArray(
                    configuraciones
                )

                    ? configuraciones

                    : []
            )
                .slice()
                .sort(
                    (
                        a,
                        b
                    ) =>

                        String(
                            b.fecha_desde
                        )
                            .localeCompare(
                                String(
                                    a.fecha_desde
                                )
                            )
                );

        }, [
            configuraciones
        ]);


    /*
    ====================================
    ABRIR
    ====================================
    */

    useEffect(() => {

        if (
            !isOpen
        ) {

            return;

        }

        const fechaInicial =
            getFechaInicial(
                configuraciones
            );

        const base =
            getConfiguracionBase(

                configuraciones,

                fechaInicial,

                centro
                    ?.configuracion ||
                null

            );

        setFormulario(
            getEstadoDesdeConfiguracion(
                base,
                fechaInicial
            )
        );

        setErrorFormulario(
            ''
        );

    }, [
        isOpen,
        centro,
        configuraciones
    ]);


    if (
        !formulario
    ) {

        return null;

    }


    /*
    ====================================
    CAMBIAR CAMPO
    ====================================
    */

    const cambiarCampo = (
        e
    ) => {

        const {

            name,

            value,

            type,

            checked

        } = e.target;

        setFormulario(
            (actual) => ({

                ...actual,

                [name]:

                    type ===
                        'checkbox'

                        ? checked

                        : value

            })
        );

        setErrorFormulario(
            ''
        );

    };


    /*
    ====================================
    CAMBIAR FECHA
    ====================================
    */

    const cambiarFecha = (
        e
    ) => {

        const fecha =
            e.target.value;

        const base =
            getConfiguracionBase(

                configuraciones,

                fecha,

                centro
                    ?.configuracion ||
                null

            );

        setFormulario(
            getEstadoDesdeConfiguracion(
                base,
                fecha
            )
        );

        setErrorFormulario(
            ''
        );

    };


    /*
    ====================================
    FEE
    ====================================
    */

    const cambiarFeeValor = (
        e
    ) => {

        const valor =
            e.target.value;

        if (
            valor === '' ||
            /^\d*(?:[.,]\d{0,2})?$/
                .test(
                    valor
                )
        ) {

            setFormulario(
                (actual) => ({

                    ...actual,

                    fee_valor:
                        valor

                })
            );

            setErrorFormulario(
                ''
            );

        }

    };


    /*
    ====================================
    VENCIMIENTO
    ====================================
    */

    const resolverVencimiento = () => {

        switch (
            formulario
                .vencimiento_opcion
        ) {

            case 'INMEDIATO':

                return {

                    vencimiento_tipo:
                        'INMEDIATO',

                    vencimiento_meses:
                        0,

                    vencimiento_dia:
                        null

                };


            case 'FIN_MES_ACTUAL':

                return {

                    vencimiento_tipo:
                        'FIN_MES',

                    vencimiento_meses:
                        0,

                    vencimiento_dia:
                        null

                };


            case 'DIA_MES_SIGUIENTE':

                return {

                    vencimiento_tipo:
                        'DIA_MES',

                    vencimiento_meses:
                        1,

                    vencimiento_dia:
                        Number(
                            formulario
                                .vencimiento_dia
                        )

                };


            case 'FIN_MES_SIGUIENTE':

            default:

                return {

                    vencimiento_tipo:
                        'FIN_MES',

                    vencimiento_meses:
                        1,

                    vencimiento_dia:
                        null

                };

        }

    };


    /*
    ====================================
    GUARDAR
    ====================================
    */

    const handleGuardar =
        async (
            e
        ) => {

            e.preventDefault();

            setErrorFormulario(
                ''
            );

            if (
                guardando
            ) {

                return;

            }

            if (
                !centro?.id
            ) {

                setErrorFormulario(
                    'No se pudo identificar el centro.'
                );

                return;

            }

            if (
                !formulario
                    .fecha_desde
            ) {

                setErrorFormulario(
                    'Indicá desde qué fecha rige la nueva configuración.'
                );

                return;

            }

            if (
                formulario
                    .fecha_desde <
                getFechaHoy()
            ) {

                setErrorFormulario(
                    'La nueva configuración debe comenzar hoy o en una fecha futura.'
                );

                return;

            }

            const fechaDuplicada =
                historial.some(
                    (item) =>

                        String(
                            item.fecha_desde
                        )
                            .substring(
                                0,
                                10
                            ) ===
                        formulario
                            .fecha_desde
                );

            if (
                fechaDuplicada
            ) {

                setErrorFormulario(
                    'Ya existe una configuración que comienza en esa fecha.'
                );

                return;

            }

            const feeTexto =
                String(
                    formulario
                        .fee_valor
                )
                    .trim();

            if (
                !/^\d+(?:[.,]\d{1,2})?$/
                    .test(
                        feeTexto
                    )
            ) {

                setErrorFormulario(
                    'Ingresá un valor válido.'
                );

                return;

            }

            const feeValor =
                Number(
                    feeTexto.replace(
                        ',',
                        '.'
                    )
                );

            if (
                !Number.isFinite(
                    feeValor
                ) ||
                feeValor <=
                    0
            ) {

                setErrorFormulario(
                    'El valor debe ser mayor a 0.'
                );

                return;

            }

            if (
                formulario
                    .fee_tipo ===
                    'PORCENTAJE' &&
                feeValor >
                    100
            ) {

                setErrorFormulario(
                    'El porcentaje no puede superar el 100%.'
                );

                return;

            }

            if (
                formulario
                    .vencimiento_opcion ===
                    'DIA_MES_SIGUIENTE'
            ) {

                const dia =
                    Number(
                        formulario
                            .vencimiento_dia
                    );

                if (
                    !Number.isInteger(
                        dia
                    ) ||
                    dia <
                        1 ||
                    dia >
                        31
                ) {

                    setErrorFormulario(
                        'El día debe estar entre 1 y 31.'
                    );

                    return;

                }

            }

            const vencimiento =
                resolverVencimiento();

            const feeBase =

                formulario
                    .fee_tipo ===
                    'FIJO_MENSUAL'

                    ? (
                        formulario
                            .fee_mensual_condicion ===
                            'MES_CON_COBROS'

                            ? 'COBRO'

                            : 'PRESTACION'
                    )

                    : formulario
                        .fee_base;

            const datos = {

                centro_id:
                    centro.id,

                fecha_desde:
                    formulario
                        .fecha_desde,

                fee_tipo:
                    formulario
                        .fee_tipo,

                fee_valor:
                    feeValor,

                fee_base:
                    feeBase,

                fee_mensual_condicion:

                    formulario
                        .fee_tipo ===
                        'FIJO_MENSUAL'

                        ? formulario
                            .fee_mensual_condicion

                        : null,

                paga_sesion_paciente:
                    formulario
                        .paga_sesion_paciente,

                paga_reunion_padres:
                    formulario
                        .paga_reunion_padres,

                paga_reunion_colegio:
                    formulario
                        .paga_reunion_colegio,

                paga_reunion_profesionales:
                    formulario
                        .paga_reunion_profesionales,

                vencimiento_tipo:
                    vencimiento
                        .vencimiento_tipo,

                vencimiento_meses:
                    vencimiento
                        .vencimiento_meses,

                vencimiento_dia:
                    vencimiento
                        .vencimiento_dia,

                observacion:
                    formulario
                        .observacion
                        .trim() ||
                    null

            };

            const resultado =
                await onGuardar(
                    datos
                );

            if (
                resultado
                    ?.ok ===
                    false
            ) {

                setErrorFormulario(
                    resultado.msg ||
                    'No se pudo guardar la configuración.'
                );

            }

        };


    const handleCerrar = () => {

        if (
            guardando
        ) {

            return;

        }

        onClose();

    };


    const labelValor =

        formulario
            .fee_tipo ===
            'PORCENTAJE'

            ? 'Porcentaje'

            : formulario
                .fee_tipo ===
                'FIJO_PRESTACION'

                ? 'Importe por prestación'

                : 'Importe mensual por paciente';


    return (

        <Modal

            isOpen={
                isOpen
            }

            onRequestClose={
                handleCerrar
            }

            shouldCloseOnOverlayClick={
                !guardando
            }

            shouldCloseOnEsc={
                !guardando
            }

            style={{

                overlay: {

                    zIndex:
                        2000,

                    backgroundColor:
                        'rgba(0, 0, 0, 0.45)',

                    display:
                        'flex',

                    alignItems:
                        'center',

                    justifyContent:
                        'center',

                    padding:
                        '1rem'

                },

                content: {

                    position:
                        'relative',

                    inset:
                        'auto',

                    border:
                        'none',

                    background:
                        'transparent',

                    padding:
                        0,

                    width:
                        '100%',

                    maxWidth:
                        '760px',

                    maxHeight:
                        '92vh',

                    overflow:
                        'hidden'

                }

            }}
        >

            <ModalEconomiaContenido
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: '92vh',
                    overflow: 'hidden'
                }}
            >

                <ModalEconomiaCabecera>

                    <div>

                        <ModalEconomiaTitulo>
                            Condiciones generales
                        </ModalEconomiaTitulo>

                        <ModalEconomiaSubtitulo>
                            {centro?.nombre || 'Centro'}
                        </ModalEconomiaSubtitulo>

                    </div>

                    <BotonCerrarModal

                        type="button"

                        onClick={
                            handleCerrar
                        }

                        disabled={
                            guardando
                        }
                    >
                        ×
                    </BotonCerrarModal>

                </ModalEconomiaCabecera>


                <CobroFormulario
                    as="form"
                    onSubmit={
                        handleGuardar
                    }
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: 0,
                        flex: 1
                    }}
                >

                    <ModalScrollContenido
                        style={{
                            flex: 1,
                            minHeight: 0,
                            overflowY: 'auto'
                        }}
                    >

                        <ModalSeccion>

                            <ModalSeccionTitulo>
                                Historial de configuraciones
                            </ModalSeccionTitulo>

                            {
                                historial.map(
                                    (item) => (

                                        <div
                                            key={
                                                item.id
                                            }
                                            style={{
                                                padding:
                                                    '0.65rem 0',

                                                borderBottom:
                                                    '1px solid #E7EEEE',

                                                fontSize:
                                                    '0.75rem',

                                                lineHeight:
                                                    1.5
                                            }}
                                        >

                                            <strong>

                                                {
                                                    formatDateDisplay(
                                                        item.fecha_desde
                                                    )
                                                }

                                                {' → '}

                                                {
                                                    item.fecha_hasta

                                                        ? formatDateDisplay(
                                                            item.fecha_hasta
                                                        )

                                                        : 'Actualidad'
                                                }

                                            </strong>

                                            <div>

                                                {
                                                    getFeeTexto(
                                                        item
                                                    )
                                                }

                                                {' · '}

                                                {
                                                    item.fee_base ===
                                                        'COBRO'

                                                        ? 'Sobre cobro'

                                                        : 'Sobre prestación'
                                                }

                                            </div>

                                        </div>

                                    )
                                )
                            }

                        </ModalSeccion>


                        <ModalSeccion>

                            <ModalSeccionTitulo>
                                Nueva configuración
                            </ModalSeccionTitulo>

                            <CobroCampo>

                                <CobroLabel>
                                    Vigente desde *
                                </CobroLabel>

                                <CobroInput

                                    type="date"

                                    name="fecha_desde"

                                    min={
                                        getFechaHoy()
                                    }

                                    value={
                                        formulario
                                            .fecha_desde
                                    }

                                    onChange={
                                        cambiarFecha
                                    }

                                    disabled={
                                        guardando
                                    }
                                />

                            </CobroCampo>

                        </ModalSeccion>


                        <ModalSeccion>

                            <ModalSeccionTitulo>
                                Condición económica
                            </ModalSeccionTitulo>

                            <CobroCamposGrid>

                                <CobroCampo>

                                    <CobroLabel>
                                        Tipo de fee
                                    </CobroLabel>

                                    <CobroSelect

                                        name="fee_tipo"

                                        value={
                                            formulario
                                                .fee_tipo
                                        }

                                        onChange={
                                            cambiarCampo
                                        }

                                        disabled={
                                            guardando
                                        }
                                    >

                                        <option value="PORCENTAJE">
                                            Porcentaje
                                        </option>

                                        <option value="FIJO_PRESTACION">
                                            Importe fijo por prestación
                                        </option>

                                        <option value="FIJO_MENSUAL">
                                            Importe fijo mensual
                                        </option>

                                    </CobroSelect>

                                </CobroCampo>


                                <CobroCampo>

                                    <CobroLabel>
                                        {labelValor} *
                                    </CobroLabel>

                                    <CobroInput

                                        type="text"

                                        inputMode="decimal"

                                        name="fee_valor"

                                        value={
                                            formulario
                                                .fee_valor
                                        }

                                        onChange={
                                            cambiarFeeValor
                                        }

                                        disabled={
                                            guardando
                                        }
                                    />

                                </CobroCampo>

                            </CobroCamposGrid>


                            {
                                formulario
                                    .fee_tipo !==
                                    'FIJO_MENSUAL'

                                    ? (

                                        <CobroCampo
                                            style={{
                                                marginTop:
                                                    '0.8rem'
                                            }}
                                        >

                                            <CobroLabel>
                                                ¿Cuándo se genera lo que corresponde al centro?
                                            </CobroLabel>

                                            <CobroSelect

                                                name="fee_base"

                                                value={
                                                    formulario
                                                        .fee_base
                                                }

                                                onChange={
                                                    cambiarCampo
                                                }
                                            >

                                                <option value="PRESTACION">
                                                    Cuando realizo la prestación
                                                </option>

                                                <option value="COBRO">
                                                    Cuando recibo el pago del paciente
                                                </option>

                                            </CobroSelect>

                                        </CobroCampo>

                                    )

                                    : (

                                        <CobroCampo
                                            style={{
                                                marginTop:
                                                    '0.8rem'
                                            }}
                                        >

                                            <CobroLabel>
                                                ¿Cuándo corresponde generar el monto mensual?
                                            </CobroLabel>

                                            <CobroSelect

                                                name="fee_mensual_condicion"

                                                value={
                                                    formulario
                                                        .fee_mensual_condicion
                                                }

                                                onChange={
                                                    cambiarCampo
                                                }
                                            >

                                                <option value="MES_CON_PRESTACIONES">
                                                    Si hubo prestaciones durante el mes
                                                </option>

                                                <option value="MES_VINCULADO">
                                                    Si el paciente estuvo vinculado al centro
                                                </option>

                                                <option value="MES_CON_COBROS">
                                                    Si hubo cobros del paciente durante el mes
                                                </option>

                                            </CobroSelect>

                                        </CobroCampo>

                                    )
                            }

                        </ModalSeccion>


                        <ModalSeccion>

                            <ModalSeccionTitulo>
                                Qué prestaciones paga el centro
                            </ModalSeccionTitulo>

                            <div
                                style={{
                                    display:
                                        'grid',

                                    gridTemplateColumns:
                                        'repeat(2, minmax(0, 1fr))',

                                    gap:
                                        '0.7rem'
                                }}
                            >

                                <label>
                                    <input
                                        type="checkbox"
                                        name="paga_sesion_paciente"
                                        checked={
                                            formulario
                                                .paga_sesion_paciente
                                        }
                                        onChange={
                                            cambiarCampo
                                        }
                                    />
                                    {' '}
                                    Sesión con paciente
                                </label>

                                <label>
                                    <input
                                        type="checkbox"
                                        name="paga_reunion_padres"
                                        checked={
                                            formulario
                                                .paga_reunion_padres
                                        }
                                        onChange={
                                            cambiarCampo
                                        }
                                    />
                                    {' '}
                                    Reunión con padres
                                </label>

                                <label>
                                    <input
                                        type="checkbox"
                                        name="paga_reunion_colegio"
                                        checked={
                                            formulario
                                                .paga_reunion_colegio
                                        }
                                        onChange={
                                            cambiarCampo
                                        }
                                    />
                                    {' '}
                                    Reunión con colegio
                                </label>

                                <label>
                                    <input
                                        type="checkbox"
                                        name="paga_reunion_profesionales"
                                        checked={
                                            formulario
                                                .paga_reunion_profesionales
                                        }
                                        onChange={
                                            cambiarCampo
                                        }
                                    />
                                    {' '}
                                    Reunión con profesionales
                                </label>

                            </div>

                        </ModalSeccion>


                        <ModalSeccion>

                            <ModalSeccionTitulo>
                                Forma habitual de liquidación
                            </ModalSeccionTitulo>

                            <CobroCamposGrid>

                                <CobroCampo>

                                    <CobroLabel>
                                        Vencimiento
                                    </CobroLabel>

                                    <CobroSelect

                                        name="vencimiento_opcion"

                                        value={
                                            formulario
                                                .vencimiento_opcion
                                        }

                                        onChange={
                                            cambiarCampo
                                        }
                                    >

                                        <option value="INMEDIATO">
                                            Inmediato
                                        </option>

                                        <option value="FIN_MES_ACTUAL">
                                            Fin del mismo mes
                                        </option>

                                        <option value="FIN_MES_SIGUIENTE">
                                            Fin del mes siguiente
                                        </option>

                                        <option value="DIA_MES_SIGUIENTE">
                                            Día específico del mes siguiente
                                        </option>

                                    </CobroSelect>

                                </CobroCampo>


                                {
                                    formulario
                                        .vencimiento_opcion ===
                                        'DIA_MES_SIGUIENTE'

                                        ? (

                                            <CobroCampo>

                                                <CobroLabel>
                                                    Día
                                                </CobroLabel>

                                                <CobroInput

                                                    type="number"

                                                    min="1"

                                                    max="31"

                                                    name="vencimiento_dia"

                                                    value={
                                                        formulario
                                                            .vencimiento_dia
                                                    }

                                                    onChange={
                                                        cambiarCampo
                                                    }
                                                />

                                            </CobroCampo>

                                        )

                                        : null
                                }

                            </CobroCamposGrid>


                            <CobroCampo
                                style={{
                                    marginTop:
                                        '0.8rem'
                                }}
                            >

                                <CobroLabel>
                                    Observación de esta versión
                                </CobroLabel>

                                <CobroTextarea

                                    name="observacion"

                                    value={
                                        formulario
                                            .observacion
                                    }

                                    onChange={
                                        cambiarCampo
                                    }

                                    maxLength={
                                        500
                                    }

                                    placeholder="Opcional"
                                />

                            </CobroCampo>

                        </ModalSeccion>


                        {
                            errorFormulario

                                ? (

                                    <div
                                        style={{
                                            marginTop:
                                                '1rem',

                                            color:
                                                '#B45059',

                                            fontSize:
                                                '0.75rem',

                                            fontWeight:
                                                600
                                        }}
                                    >
                                        {errorFormulario}
                                    </div>

                                )

                                : null
                        }

                    </ModalScrollContenido>


                    <ModalAcciones
                        style={{
                            flexShrink: 0,
                            marginTop: 0,
                            paddingTop: '0.9rem',
                            backgroundColor: '#FFFFFF'
                        }}
                    >

                        <BotonSecundario
                            type="button"
                            onClick={
                                handleCerrar
                            }
                            disabled={
                                guardando
                            }
                        >
                            Cancelar
                        </BotonSecundario>


                        <BotonPrincipal
                            type="submit"
                            disabled={
                                guardando
                            }
                        >

                            {
                                guardando

                                    ? 'Guardando...'

                                    : 'Guardar nueva configuración'
                            }

                        </BotonPrincipal>

                    </ModalAcciones>

                </CobroFormulario>

            </ModalEconomiaContenido>

        </Modal>

    );

};


export default ConfiguracionCentroModal;